import { render, staticRenderFns } from "./LiveSponsorTable.vue?vue&type=template&id=4370a1ec"
import script from "./LiveSponsorTable.vue?vue&type=script&lang=js"
export * from "./LiveSponsorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports